/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import BaseCom from './BaseCom';

export default class MessageDialog extends BaseCom {

    render() {
        return <Modal show>
            <Modal.Header>
                <Modal.Title>{this.props.title ?? 'Alert'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.props.message ?? this.props.children}
            </Modal.Body>
        </Modal>;
    }
}